import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import base_url from "./../../api/bootapi";
import Swal from 'sweetalert2';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import newlogo from "./../../assets/new-linsoa-logo.jpg";


export default function Footer() {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [backdropopen, setbackdropopen] = useState(false);

  const onSubmit = (data2) => {
    let email_id = data2.email_id;
    let status = 1;

    let data = {
      email_id,
      status,
    };
    postContact(data);
  };

  const postContact = (data) => {
    setbackdropopen(true);
    axios.post(`${base_url.api1}/tourapp/newsletter`, data)
      .then((response) => {
        setbackdropopen(false);
        Swal.fire({
          position: 'center',
          width: '62rem',
          icon: 'success',
          title: 'Thank You For Subscribing',
          showCloseButton: true,
          showConfirmButton: false,
          timer: 1500
        })
        document.getElementById("myForm").reset();
      },
        (error) => {
          setbackdropopen(false);
          // toast.error("User Not Created!");
          Swal.fire({
            position: 'center',
            width: '62rem',
            icon: 'error',
            title: 'Something went wrong!',
            showConfirmButton: false,
            showCloseButton: true,
          })
        });
  };




  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <footer class="page-footer font-small pt-4">
        <div class="container text-md-left">
          <div style={{ marginTop: "100px" }}>
            <div class="row">
              <div class="col-md-3 mt-md-0 mt-3">
               <Link>
                  <img src={newlogo} alt="" className="img-fluid mb-4" style={{ width:"150px",borderRadius:"50%"}}/>
                </Link>
                {/* <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Vitae, voluptatem corporis error non,Lorem ipsum dolor sit
                  amet, con sectetur adipiscing elit.
                </p> */}
              </div>
              <div class="col-md-3 mb-md-0 mb-3">
                <h5 class="footer_heading">Services</h5>
                <ul class="list-unstyled footer_ul_style">
                  <li>
                    <a
                      href="http://linsoatours.com/articles/about-us/"
                      target="_blank"
                    >
                      About Us
                    </a>
                  </li>
                  {/* <li>
                    <a>Listing</a>
                  </li> */}
                  <li>
                    <a>How it Works</a>
                  </li>
                  <li>
                    <a>Our Services</a>
                  </li>
                  {/* <li>
                    <a>Our Blog</a>
                  </li> */}
                  <li><Link to="/faq">FAQs</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
              <div class="col-md-3 mb-md-0 mb-3">
                <h5 class="footer_heading ">Tours</h5>
                <ul class="list-unstyled footer_ul_style">
                  <li><Link to="/view-tours/20/Lizensk">Lizensk</Link></li>
                  <li><Link to="/view-tours/21/Sanz">Sanz</Link></li>
                  <li><Link to="/view-tours/22/Kerestier">Kerestier</Link></li>
                </ul>
              </div>
              <div class="col-md-3 mb-md-0 mb-3">
                <h5 class="footer_heading">Subscribe us</h5>
                <div class="mb-5 flex-center">
                  {/* <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </p> */}
                  {/* <div className="emailid">
                    <input type="email" placeholder="Enter Your Email Address" />
                    <button style={{ marginTop: "5%" }}>SUBSCRIBE NOW</button>
                  </div> */}
                  <form id="myForm" onSubmit={handleSubmit(onSubmit)}>
                    <div className="emailid">
                      <input type="email" className="form-control underline-input" placeholder="Enter Your Email Address"
                        {...register("email_id", { required: true, pattern: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$/, })}
                      />
                      {errors.email_id && (<p className="errormessage">Email is Required</p>)}
                      <button style={{ marginTop: "5%" }}>SUBSCRIBE NOW</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="row_copyright">
        <div className="container">
          <div className="row mx-0 p-0">
            <div className="col-md-6 d-flex align-items-center">
              <p className="mb-0">
                Linsoa Tours &copy; 2022 All Rights Reserved
              </p>
            </div>
            <div className="col-md-6">
              {/* <p>Linsoa Tours &copy; 2022 All Rights Reserved</p> */}
              <div style={{ float: "right" }}>
                <a class="fa fa-facebook"></a>
                <a class="fa fa-twitter"></a>
                <a class="fa fa-instagram"></a>
                <a
                  style={{
                    paddingTop: "14px",
                    paddingRight: "10px",
                    paddingBottom: "14px",
                    paddingLeft: "13px",
                  }}
                  class="fa fa-google-plus"
                ></a>
                <a class="fa fa-linkedin"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
